/**
 * Load Plugins
 * If you don't see a plugin below it might be autloaded via webpack
 * Check webpack.mix.js for autoloaded plugins.
 */

require('motion-ui/dist/motion-ui.js');
require('@fancyapps/fancybox');
require('jquery-match-height');
require('slick-carousel');

import { Foundation } from './foundation';
Foundation.addToJquery(jQuery);

import { WOW } from 'wowjs';

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
let token = window.csrfTokenValue;
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = window.csrfTokenValue;
}


/**
 * Application script
 */

$(document).foundation();

$(function() {

    // Wowjs
    var wow = new WOW(
        {
            boxClass:     'wow',            // animated element css class (default is wow)
            animateClass: 'is-animating',   // animation css class (default is animated)
            offset:       0,                // distance to the element when triggering the animation (default is 0)
            mobile:       false,             // trigger animations on mobile devices (default is true)
            live:         false,             // act on asynchronously loaded content (default is true)
            callback:     function(box) {
            // the callback is fired every time an animation is started
            // the argument that is passed in is the DOM node being animated
            },
            scrollContainer: null // optional scroll container selector, otherwise use window
        }
    );
    $('.wow-wrapper').addClass('is-animating');
    wow.init();

    // Google map
   //  if($('.map-holder').length > 0) {
   //     $('.location-map').each(function(){
   //         var element = $("#"+$(this).attr('id'));
   //         var zoom = element.data('zoom');
   //         var lat = element.data('lat');
   //         var long = element.data('long');
   //         initializeMap(document.getElementById($(this).attr('id')), zoom, lat, long);
   //         google.maps.event.trigger(element, "resize");
   //     });
   // }

   // function initializeMap(element, zoom, lat, long) {
   //     var mapOptions = {
   //         zoom : zoom,
   //         scrollwheel : false,
   //         draggable: true,
   //         center : new google.maps.LatLng(lat, long)
   //     };
   //     var map = new google.maps.Map(element, mapOptions);
   //     var marker = new google.maps.Marker({
   //         position: new google.maps.LatLng(lat, long),
   //         map: map
   //     });
   // }

});



// WEBPACK FOOTER //
// ./public/js/app.js